"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.generateOrder = void 0;
var ejson_1 = __importDefault(require("ejson"));
var generateOrder = function (orderInput, tasks) {
    var order = __assign({ todo: [], inprogress: [], inreview: [], done: [], wontdo: [] }, orderInput);
    var _loop_1 = function (key) {
        order[key] = order[key].filter(function (taskUUID) {
            var _a;
            return ((_a = tasks.find(function (task) { return task.uuid === taskUUID; })) === null || _a === void 0 ? void 0 : _a.status.id) === key;
        });
        for (var _b = 0, _c = tasks.filter(function (task) { return task.status.id === key && !order[key].includes(task.uuid); }); _b < _c.length; _b++) {
            var task = _c[_b];
            order[key].push(task.uuid);
        }
    };
    for (var _i = 0, _a = Object.keys(order); _i < _a.length; _i++) {
        var key = _a[_i];
        _loop_1(key);
    }
    return ejson_1["default"].clone(order);
};
exports.generateOrder = generateOrder;
